module.exports = __webpack_public_path__ + "img/home.0f3d1aa5.svg";